import type { OptimizedSearchResult } from '@rover/rsdk/src/apiClient/latest/model/optimizedSearchResult';

const getReviewDetails = (
  preferCatReviews: boolean,
  {
    catReviewPhotoUrl,
    reviewDogPhotoUrl,
    catReviewText,
    reviewText,
    catReviewerShortName,
    dogReviewerShortName,
  }: OptimizedSearchResult
): {
  reviewText: string;
  reviewPhotoUrl:
    | OptimizedSearchResult['catReviewPhotoUrl']
    | OptimizedSearchResult['reviewDogPhotoUrl'];
  reviewerShortName: string;
} => {
  // catReviewPhotoUrl is not accounted for because we have fallback images available
  const shouldDisplayCatReview = preferCatReviews && catReviewText && catReviewerShortName;
  return {
    reviewText: (shouldDisplayCatReview ? catReviewText : reviewText) ?? '',
    reviewPhotoUrl: shouldDisplayCatReview ? catReviewPhotoUrl : reviewDogPhotoUrl,
    reviewerShortName: (shouldDisplayCatReview ? catReviewerShortName : dogReviewerShortName) ?? '',
  };
};

export default getReviewDetails;
